import React, { useState } from "react";
import { Card, Button, Badge, Avatar, Input } from "../../design-system";
import { Icon, SupHeader, FilterChip, CatIcon } from "./atoms";
import { SUP_KB, CAT, resourceById } from "./data";
import { useSoporteNav } from "./nav";

/**
 * Soporte IT · Base de conocimiento — artículos internos de soporte,
 * filtrables por categoría. Convierte soluciones de tickets en guías. UI-only.
 */
function SoporteConocimiento() {
  document.title = "Base de conocimiento · Soporte IT | Kronaly";
  const nav = useSoporteNav();
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("all");
  const cats = ["all", ...Array.from(new Set(SUP_KB.map((a) => a.cat)))];
  const rows = SUP_KB.filter((a) => (cat === "all" || a.cat === cat) && (!q.trim() || a.title.toLowerCase().includes(q.toLowerCase())));

  return (
    <div className="kr-page">
      <SupHeader
        eyebrow="Soporte IT"
        title="Base de conocimiento"
        subtitle="Artículos internos de soporte. Convierte soluciones de tickets en guías reutilizables."
        actions={<Button variant="primary" icon="Plus">Nuevo artículo</Button>}
      />

      <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar en la base de conocimiento…" icon="Search" style={{ flex: 1, minWidth: 260, maxWidth: 420, height: 38 }} />
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
          {cats.map((c) => <FilterChip key={c} active={cat === c} onClick={() => setCat(c)}>{c === "all" ? "Todas" : CAT[c]?.label || c}</FilterChip>)}
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 14 }} data-responsive-grid="3">
        {rows.map((a) => (
          <Card key={a.id} onClick={() => {}} style={{ display: "flex", flexDirection: "column", gap: 12, cursor: "pointer" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <CatIcon cat={a.cat} size={36} iconSize={18} />
              <Badge tone={a.visibility === "Público" ? "info" : "neutral"} variant="soft">{a.visibility}</Badge>
            </div>
            <div style={{ fontSize: 14, fontWeight: 600, color: "var(--kr-fg-strong)", lineHeight: 1.35 }}>{a.title}</div>
            <div style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 11, color: "var(--kr-fg-muted)", marginTop: "auto", paddingTop: 12, borderTop: "1px solid var(--kr-border-subtle)" }}>
              <span style={{ display: "inline-flex", alignItems: "center", gap: 5 }}><Avatar name={a.author} size={18} />{a.author}</span>
              <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}><Icon name="eye" size={12} />{a.views}</span>
              <span style={{ marginLeft: "auto", fontFamily: "var(--kr-font-mono)" }}>{a.updated}</span>
            </div>
          </Card>
        ))}
      </div>

      <Card style={{ background: "var(--kr-action-soft-bg)", borderColor: "var(--kr-green-200)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}>
          <span style={{ width: 44, height: 44, borderRadius: 10, background: "#fff", display: "inline-flex", alignItems: "center", justifyContent: "center", color: "var(--kr-action-soft-fg)" }}><Icon name="bookOpen" size={22} /></span>
          <div style={{ flex: 1, minWidth: 220 }}>
            <div style={{ fontSize: 14, fontWeight: 600, color: "var(--kr-fg-strong)" }}>Crea artículos directamente desde un ticket resuelto</div>
            <div style={{ fontSize: 12, color: "var(--kr-fg-primary)", marginTop: 2 }}>En cualquier ticket con solución aplicada, usa «Crear artículo a partir de la solución» para documentarlo en segundos.</div>
          </div>
          <Button variant="primary" icon="ArrowRight" onClick={() => nav.go("tickets")}>Ver tickets resueltos</Button>
        </div>
      </Card>
    </div>
  );
}

export default SoporteConocimiento;
